import { Button, Input } from 'antd';
import React, { FC, useState } from 'react';
import { TQuestionInPoll } from 'shared/types/poll.types';
import { CloseOutlined } from '@ant-design/icons';
import QuestionDrawer from 'features/poll/questionDrawer/QuestionDrawer';
import Required from 'shared/components/required/Required';
import style from './index.module.scss';

type TQuestionsSectionProps = {
  onOpen: () => void;
  questions: TQuestionInPoll[];
  onDelete: (id: number) => void;
  onUpdate: (data: TQuestionInPoll) => void;
};

const QuestionsSection: FC<TQuestionsSectionProps> = ({ onOpen, questions, onDelete, onUpdate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [currentQuestion, setCurrentQuestion] = useState<TQuestionInPoll | undefined>();
  const onDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const openDrawerWithData = (question: TQuestionInPoll) => {
    setIsDrawerOpen(true);

    setCurrentQuestion(question);
  };

  const deleteQuestion = (id: number | undefined, e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(Number(id));
  };

  const onUpdateQuestion = (data: TQuestionInPoll) => {
    data.id = Number(currentQuestion?.id);
    onUpdate(data);
  };

  return (
    <div className={style.wrapper}>
      <h3>
        <Required>Вопросы</Required>
      </h3>
      <div className={style.questions}>
        {questions.map(elem => (
          <div className={style.answer} onClick={() => openDrawerWithData(elem)} key={elem.id}>
            <Input
              placeholder="Введите вариант ответа"
              value={elem.title}
              onChange={(e: React.ChangeEvent) => elem.title}
              className={style.input}
            />
            <CloseOutlined
              className={style['cross-icon']}
              onClick={(e: React.MouseEvent) => deleteQuestion(elem.id, e)}
            />
          </div>
        ))}
      </div>
      <QuestionDrawer
        isOpen={isDrawerOpen}
        onClose={onDrawerClose}
        onCreate={onUpdateQuestion}
        question={currentQuestion}
      />

      <Button className={style.button} onClick={onOpen}>
        + Добавить
      </Button>
    </div>
  );
};

export default QuestionsSection;
